export default __webpack_public_path__ + "static/media/logo.f8e9694a.svg";